import * as types from '../mutation-types'
import api from '@/api/ideas'

// initial state
const state = {
    ideas: [],
    ideasMetaInfo: {},
    ideasCount: 0,
    featuredIdeas: [],
    loaded: false,
}

const getters = {
    ideas: state => state.ideas,
    ideasMetaInfo: state => state.ideasMetaInfo,
    ideasCount: state => state.ideasCount,
    ideasLoaded: state => state.loaded,
    featuredIdeas: state => state.featuredIdeas,
}

const actions = {
    getIdeas({ commit }, params) {
        commit(types.SET_IDEAS_LOADED, false );
        api.getIdeas(params, (response) => {
            commit(types.SET_IDEAS, response._embedded.Post );
            commit(types.SET_IDEAS_META, response );
            commit(types.SET_IDEAS_LOADED, true );
            if(!params.idCategory && !params.status) {
                commit(types.SET_IDEAS_COUNT, response._total );
            }
        })
    },
    cleanIdeas({ commit }) {
        commit(types.CLEAN_IDEAS);
    },
    getFeaturedIdeas({ commit }, params) {
        params.featured = 'notnull'
        api.getIdeas(params, (response) => {
            commit(types.SET_FEATURED_IDEAS, response._embedded.Post );
        })
    },
}

const mutations = {
    [types.SET_IDEAS] (state, ideas ) {
        state.ideas =[...state.ideas, ...ideas]
    },
    [types.CLEAN_IDEAS] (state ) {
        state.ideas =[]
    },
    [types.SET_IDEAS_META] (state, ideasMetaInfo ) {
        state.ideasMetaInfo = ideasMetaInfo
    },
    [types.SET_FEATURED_IDEAS] (state, ideas ) {
        state.featuredIdeas = ideas
    },
    [types.SET_IDEAS_COUNT] (state, count ) {
        state.ideasCount = count
    },
    [types.SET_IDEAS_LOADED] (state, status ) {
        state.loaded = status
    },
}


export default {
    state,
    getters,
    actions,
    mutations
}


